import React from "react";
import ProgressCircle from "../../layout/ProgressCircle";
import MenuButtons from "../../layout/MenuButtons";

const ActivityHeader = ({ section, topic, current, total }) => {
  return (
    <header
      className={`header bg-${section.data.accentColor} relative flex lg:text-center`}
    >
      <div className="hold flex py-9 lg:py-9 pr-15 pl-50 flex items-center w-full justify-between">
        {current && total && (
          <div style={{ width: "50px" }}>
            <ProgressCircle current={current} total={total} />
          </div>
        )}

        <span className="ml-10 md:ml-0 header-link block uppercase text-white font-md text-xs lg:text-lg leading-none font-bold tracking-wide">
          {section.data.title || section.title}
          <span className="block font-bold font-secondary pt-8 lg:pt-5 normal-case text-13">
            {topic.data.title || topic.title}
          </span>
        </span>

        <MenuButtons color="white" />
      </div>
    </header>
  );
};

export default ActivityHeader;
